import {combineReducers} from 'redux';
import inputField from './input-field';
import chatBody from './chat-body';
import chatRoot from './chat-root';
import chatHeader from './chat-header';
import { reducer as reduxFormReducer } from 'redux-form';

const app = combineReducers({
  inputField,
  chatBody,
  chatRoot,
  chatHeader,
  form: reduxFormReducer
});

export default app;
